const labelList = [
  {
    id: 301,
    label: 'High Priority',
    value: 301,
    type: 1,
    color: '#dc3545',
  },
  {id: 302, label: 'Important', value: 302, type: 2, color: '#198754'},
  {id: 303, label: 'Crema', value: 303, type: 3, color: 'primary.main'},
  {
    id: 304,
    label: 'Work Place',
    value: 304,
    type: 4,
    color: 'text.secondary',
  },
];
export default labelList;
